import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import PrimaryHeader from '../../components/PrimaryHeader';
import EmptyState from '../../components/EmptyState';
import Loader from '../../components/Loader';
import { useUser } from '@lore/auth';
import SupportQuestion from './SupportQuestion';
import IntercomQuestion from './IntercomQuestion';
import useIntents from '../../hooks/useIntents';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export default function Layout(props) {
  const title = `Looking for support or resources?`;
  const subtitle = (
    <>
      Whether you're looking for quick, self-guided resources or personalized
      support from our team, we're here to ensure you get the help you need to succeed.
    </>
  );

  const { isEducator, isPartner } = useIntents();

  const educatorSupportQuestions = useConnect('supportQuestion.find', {
    where: {
      eager: {
        $where: {
          audience: 'Educator'
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'order asc'
    }
  });

  const partnerSupportQuestions = useConnect('supportQuestion.find', {
    where: {
      eager: {
        $where: {
          audience: 'Partner'
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'order asc'
    }
  });

  if (
    educatorSupportQuestions.state === PayloadStates.FETCHING ||
    partnerSupportQuestions.state === PayloadStates.FETCHING
  ) {
    return (
      <>
        <Helmet>
          <title>Your network resources</title>
        </Helmet>
        <PrimaryHeader
          style="simple"
          title={title}
          subtitle={subtitle}
        />
        <div className="container page">
          <Loader />
        </div>
      </>
    );
  }

  const supportQuestions = {
    state: PayloadStates.RESOLVED,
    data: []
  };

  if (isEducator) {
    supportQuestions.data = supportQuestions.data.concat(educatorSupportQuestions.data)
  }

  if (isPartner) {
    supportQuestions.data = supportQuestions.data.concat(partnerSupportQuestions.data)
  }

  // if (supportQuestions.data.length === 0) {
  //   return (
  //     <>
  //       <Helmet>
  //         <title>Your network resources</title>
  //       </Helmet>
  //       <PrimaryHeader
  //         style="simple"
  //         title={title}
  //         subtitle={subtitle}
  //       />
  //       <div className="container page">
  //         <EmptyState
  //           icon={QuestionMarkCircleIcon}
  //           title="There are currently no support resources available."
  //         />
  //       </div>
  //     </>
  //   );
  // }

  return (
    <>
      <Helmet>
        <title>Your network resources</title>
      </Helmet>
      <PrimaryHeader
        style="simple"
        title={title}
        subtitle={subtitle}
      />
      <div className="px-8 mb-12 space-y-4">
        <IntercomQuestion />
        {supportQuestions.data.map(function(supportQuestion, index) {
          return (
            <SupportQuestion
              key={supportQuestion.id}
              supportQuestion={supportQuestion}
            />
          );
        })}
      </div>
    </>
  );
};
